export default "__VITE_ASSET__TBvuoROw__"